import { Guid } from "@/Common/Models/Guid";
import { SortDirection } from "@/Common/Models/UI/Enums";
import { LicenseDto } from "./LicenseDto";

class GetManualLabsRequestFilteringCriteria {
    public from: Date | null;
    public to: Date | null;
    public licenseNumbers: LicenseDto[];
    public pageNumber: number = 1;
    public pageSize: number = 50;
    public totalRows: number = 0;
    public sortDirection: SortDirection = SortDirection.ASC;
    public searchText: string = "";
    public selectedCliniciansContactFacetIds: Guid[] = [];
    public showAbnormalResultsOnly = false;
    public hideLabResultsFiledByColleague = false;

    constructor(fields?: Partial<GetManualLabsRequestFilteringCriteria>) {
        Object.assign(this, fields);
    }
}

export { GetManualLabsRequestFilteringCriteria };
